import { render, staticRenderFns } from "./ProductsTextile.vue?vue&type=template&id=79b7f0d6&"
import script from "./ProductsTextile.vue?vue&type=script&lang=js&"
export * from "./ProductsTextile.vue?vue&type=script&lang=js&"
import style0 from "./ProductsTextile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductsTextile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports